import { render, staticRenderFns } from "./StatusFilter.vue?vue&type=template&id=f87630b0&"
import script from "./StatusFilter.vue?vue&type=script&lang=js&"
export * from "./StatusFilter.vue?vue&type=script&lang=js&"
import style0 from "./StatusFilter.vue?vue&type=style&index=0&id=f87630b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports